// "@name" typed in a search field, to limit the search to one account.

// The word the caret is in, when it is @ and at least one more character:
// { start, end, query } with query the name after the @, else null.
export const mentionAt = (text, caret) => {
  const start = text.lastIndexOf(' ', caret - 1) + 1
  const found = text.indexOf(' ', caret)
  const end = found === -1 ? text.length : found
  const word = text.slice(start, end)
  if (caret < start || !/^@\S+$/.test(word)) return null
  return { start, end, query: word.slice(1) }
}

// The text without [start, end), one space where the word was.
export const withoutRange = (text, start, end) =>
  `${text.slice(0, start)} ${text.slice(end)}`.replace(/\s+/g, ' ').trim()
